// Action rapide « Point de situation » (sprint 6, CU-105 et lot 5).
// Seule une question en langage naturel part au serveur, sans intention codée : le
// modèle choisit lui-même les outils d'alerte (LLM-14). Le niveau « approfondi » est
// forcé pour cette question sans modifier la préférence mémorisée de l'utilisateur.
export const SITUATION_QUESTION = 'Y a-t-il des choses anormales à surveiller en ce moment ?';
export const SITUATION_EFFORT = 'approfondi';
// Nom unique de l'action (tuile d'accueil, puce du compositeur, info-bulle du niveau)
export const SITUATION_LABEL = 'Point de situation';
